import * as React from "react";
import { forwardRef } from "react";
const ArrowLeftIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m3.41425 7.00025 3.293-3.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-5 5c-.391.391-.391 1.023 0 1.414l5 4.99995c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.4139l-3.293-3.29305H15.0002c.553 0 1-.448 1-1s-.447-1-1-1z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(ArrowLeftIcon);
export { ForwardRef as ArrowLeftIcon };